const customAvatarURLPattern = /^\/api\/v1\/talk\/avatars\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function customAvatarURL(value: unknown): string | undefined {
  return typeof value === "string" && customAvatarURLPattern.test(value) ? value : undefined;
}

export function avatarUploadContentType(file: File): "image/jpeg" | "image/png" | undefined {
  if (file.type === "image/jpeg" || file.type === "image/png") return file.type;
  if (/\.jpe?g$/i.test(file.name)) return "image/jpeg";
  if (/\.png$/i.test(file.name)) return "image/png";
  return undefined;
}
